var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('project-index',{attrs:{"tableColCheck":_vm.tableColCheck,"plat-name":"metabo"},scopedSlots:_vm._u([{key:"projectSign",fn:function({text,record}){return _c('span',{},[_vm._v(" 代谢组-"+_vm._s(text.value)+" ")])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }